"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get CustomValueResponse () {
        return CustomValueResponse;
    },
    get GetEmployeeDetailResponse () {
        return GetEmployeeDetailResponse;
    },
    get GetEmployeeDetailsHistoryResponse () {
        return GetEmployeeDetailsHistoryResponse;
    },
    get GetEmployeeDetailsResponse () {
        return GetEmployeeDetailsResponse;
    }
});
const _bson = require("bson");
const _zod = require("zod");
const _models = require("@performyard/models");
const _utilsisomorphic = require("@performyard/utils-isomorphic");
const CustomValueUser = _zod.z.object({
    _id: _zod.z.instanceof(_bson.ObjectID),
    name: _zod.z.string().default(""),
    externalIds: _zod.z.record(_zod.z.string().nullable()).optional()
});
const GetEmployeeDetailResponse = _zod.z.object({
    asOf: _utilsisomorphic.transformDateToUTCString.nullable().optional(),
    updatedOn: _utilsisomorphic.transformDateToUTCString.nullable().optional(),
    company: _zod.z.instanceof(_bson.ObjectID),
    editable: _zod.z.boolean(),
    _id: _zod.z.instanceof(_bson.ObjectID),
    // get just integrations field from CustomFieldModel
    integrations: _models.CustomFieldIntegration.optional(),
    level: _models.CustomFieldModel.shape.level,
    options: _zod.z.array(_zod.z.string()).optional(),
    order: _zod.z.number().default(0),
    type: _models.CustomFieldTypes,
    value: _zod.z.union([
        _models.FieldValueModel,
        _utilsisomorphic.transformDateToUTCString,
        _zod.z.object({
            _id: _zod.z.instanceof(_bson.ObjectID),
            name: _zod.z.string().nullable().default("")
        }),
        _zod.z.array(_zod.z.object({
            _id: _zod.z.instanceof(_bson.ObjectID),
            name: _zod.z.string().nullable().default("")
        }))
    ]).optional(),
    values: _zod.z.array(_zod.z.union([
        _models.FieldValueModel,
        _zod.z.object({
            _id: _zod.z.instanceof(_bson.ObjectID),
            name: _zod.z.string().nullable().default("")
        }),
        _zod.z.array(_zod.z.object({
            _id: _zod.z.instanceof(_bson.ObjectID),
            name: _zod.z.string().nullable().default("")
        }))
    ])).optional(),
    name: _zod.z.string(),
    updater: CustomValueUser.optional().nullable(),
    user: CustomValueUser.optional(),
    tags: _zod.z.array(_zod.z.string()).optional(),
    value_id: _zod.z.instanceof(_bson.ObjectID).optional(),
    isScimManaged: _zod.z.boolean().optional()
});
const GetEmployeeDetailsResponse = _zod.z.object({
    customFields: _zod.z.array(GetEmployeeDetailResponse)
});
const CustomValueResponse = _zod.z.object({
    /**
	 * The id of this value.
	 */ _id: _zod.z.instanceof(_bson.ObjectID),
    company: _zod.z.instanceof(_bson.ObjectID),
    field: _zod.z.instanceof(_bson.ObjectID),
    user: CustomValueUser,
    value: _zod.z.union([
        _models.FieldValueModel,
        _zod.z.object({
            _id: _zod.z.instanceof(_bson.ObjectID),
            name: _zod.z.string()
        }),
        _zod.z.array(_zod.z.object({
            _id: _zod.z.instanceof(_bson.ObjectID),
            name: _zod.z.string()
        }))
    ]).optional().nullable(),
    values: _zod.z.union([
        _zod.z.array(_zod.z.string()),
        _zod.z.array(_zod.z.instanceof(_bson.ObjectID)),
        _zod.z.array(_zod.z.number()),
        _zod.z.array(_zod.z.date()),
        _zod.z.array(_zod.z.null()),
        _zod.z.array(_zod.z.object({
            _id: _zod.z.instanceof(_bson.ObjectID),
            name: _zod.z.string()
        }))
    ]).optional().nullable(),
    deleted: _zod.z.boolean().optional(),
    asOf: _utilsisomorphic.transformDateToUTCString,
    comment: _zod.z.string().nullish(),
    externalSource: _zod.z.string().nullish(),
    updater: CustomValueUser.nullish(),
    origin: _zod.z.string().nullish(),
    updatedOn: _utilsisomorphic.transformDateToUTCString.nullish(),
    value_id: _zod.z.instanceof(_bson.ObjectID).optional()
});
const GetEmployeeDetailsHistoryResponse = _zod.z.object({
    _id: _zod.z.instanceof(_bson.ObjectID),
    name: _zod.z.string(),
    type: _models.CustomFieldTypes,
    history: _zod.z.array(CustomValueResponse)
});
